import Loading from "../../../utils/components/Loading";
import SetComponent from "./SetComponent";

export const SET_TYPES = {
  REVISION_SET: {
    setUrl: "revision_set",
    subSetUrl: "revision_set_detail",
    translateKey: "revision_sets",
  },
  LOCATION_SET: {
    setUrl: "site_set",
    subSetUrl: "site_set_detail",
    translateKey: "location_sets",
    importFromExcel: true,
    hasLayers: true,
    qr: true,
  },
  METADATA_SET: {
    setUrl: "metadata_set",
    subSetUrl: "metadata_set_detail",
    translateKey: "metadata_sets",
    checkboxOptions: {
      label: "multi_select_label",
      name: "multi_select",
    },
  },
  STATUS_SET: {
    setUrl: "status_set",
    subSetUrl: "status_set_detail",
    translateKey: "status_sets",
    checkboxOptions: {
      label: "auto_change_label",
      name: "auto_change",
    },
  },
};

const Sets = ({
  sets,
  setsLoading,
  handleDelete,
  handleAddDetail,
  type,
  handleUpdate = () => false,
  roles = [],
}) => {
  return (
    <div className="Sets">
      {setsLoading && <Loading />}
      {sets
        .sort((a, b) => a.id - b.id)
        .map((set) => (
          <SetComponent
            key={set.id}
            data={set}
            handleDelete={handleDelete}
            handleAddDetail={handleAddDetail}
            type={type}
            handleUpdate={handleUpdate}
            roles={roles}
          />
        ))}
    </div>
  );
};

export default Sets;
